export const DESCRIPTION_ADDRESS =
  "Commandez vos plats préférés en quelques clics !";

export const DRIVER = "Driver";
export const SHOP = "Shop";

export const PLACEHOLDER_TEXT = "3 rue des jardins, Nice";

export const TEXT_VALIDATION_DELETE_ACCOUNT =
  "Attention, la suppression de votre compte est définitive. Toutes vos données (historique, préférences, moyens de paiement, etc…) seront effacées et vous ne pourrez plus y accéder. Voulez-vous continuer ?";

export const TEXT_VALIDATION_DELETE_CB =
  "Cette action est définitive. Vous ne pourrez plus utiliser cette carte pour vos paiements.";

export const TEXT_CANCEL_ORDER =
  "Êtes-vous sûr(e) de vouloir annuler votre commande ?";
export const DEFAULT_TEXT = "Choisissez un restaurant";
export const TEXT_VALIDATION_USE_CB =
  "Utiliser cette carte pour tous vos prochains paiements ?";
export const ACCOUNT_TEXTS = {
  PASSWORD: {
    TITLE: "Mot de passe",
    SUBTITLE: "Pour changer votre mot de passe, cliquez sur le bouton ci-dessous.",
    BUTTON_LABEL: "Réinitialiser le mot de passe",
    DESCRIPTION:
      "Vous recevrez un e-mail contenant un lien sécurisé pour réinitialiser votre mot de passe.",
    ICON: "Mail",
  },
  DELETE_ACCOUNT: {
    TITLE: "Supprimer mon compte",
    SUBTITLE:
      "Si vous supprimez votre compte, vous perdrez définitivement toutes vos données.",
    BUTTON_LABEL: "Supprimer mon compte",
    ICON: 'Trash'
  },
};
export const cartDescription = "Une petite faim ? Remplissez votre panier !";